module.exports = __webpack_public_path__ + "img/ring_y_c_null_0@2x.f416dd36.png";